export default {
  install(Vue, { api }) {
    Vue.prototype.$api = api;
  },
};
